/**
 * Import Fontawesome individual icons.
 * See: https://fontawesome.com/how-to-use/on-the-web/advanced/svg-javascript-core
 */

// Font awesome core
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Icons imports
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faCaravan } from '@fortawesome/free-solid-svg-icons'
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons'
import { faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { faHeartBroken } from '@fortawesome/free-solid-svg-icons'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

// Load icons into the library
library.add(faAngleLeft)
library.add(faAngleRight)
library.add(faBriefcase)
library.add(faCaravan)
library.add(faChevronCircleLeft)
library.add(faChevronCircleRight)
library.add(faEllipsisV)
library.add(faEnvelope)
library.add(faFacebookSquare)
library.add(faFilter)
library.add(faFileInvoice)
library.add(faHeart)
library.add(faHeartBroken)
library.add(faShoppingCart)
library.add(faSignOutAlt)
library.add(faTrashAlt)
library.add(faTwitter)
library.add(faWhatsapp)

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch()
